export const startedData = {
  id: 1,
  content: "Make more <b>effective <br> decisions</b> in <strong>REAL TIME</strong>"
}
